import {
  BonificoOrderDTO,
  purchasedItemSnapshotOf,
} from "./BonificoOrderDTO.ts";

export const INVOICE_ITEM_DESCRIPTION_MAX_LENGTH = 255;

type InvoicedItem = { analyticsTag?: string; productClass?: string };

export function standardInvoiceItemDescriptionOfItem(
  item?: InvoicedItem,
): string | undefined {
  return item?.analyticsTag || item?.productClass || undefined;
}

export function standardInvoiceItemDescriptionOf(
  order: BonificoOrderDTO,
): string | undefined {
  return standardInvoiceItemDescriptionOfItem(purchasedItemSnapshotOf(order));
}

export function invoiceItemDescriptionPlaceholder(
  standardDescription?: string,
): string {
  return standardDescription
    ? `Se vuota: ${standardDescription}`
    : "Se vuota: la descrizione standard del prodotto";
}

export function invoiceItemDescriptionPlaceholderOf(
  order: BonificoOrderDTO,
): string {
  return invoiceItemDescriptionPlaceholder(
    standardInvoiceItemDescriptionOf(order),
  );
}

export function standardInvoiceItemDescriptionLabel(
  standardDescription?: string,
): string {
  return standardDescription
    ? `Descrizione standard: ${standardDescription}`
    : "Descrizione standard del prodotto";
}

export function chosenInvoiceItemDescription(
  typedDescription: string,
): string | null {
  return typedDescription.trim() || null;
}
